<template>
	<div class="fondoModal">
		<div>
			<div>
				<div class="card text-left">
					<div class="card-header">
						<div class="row">
							<div class="col text-left">
								Mi perfil de usuario
							</div>
							<div class="col text-right text-danger" v-if="usu.fecha_expiracion_cuenta">
								<strong>
									<span class="fa fa-calendar mr-1"></span>
									Caduca: {{usu.fecha_expiracion_cuenta | moment('DD-MM-YYYY')}}
								</strong>
							</div>
							<div class="pr-3">
								<button type="button" class="close" aria-label="Close" @click="cerrar">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
						</div>
					</div>
					<div class="card-body bg-light">
						<h5>
							<span class="fa fa-user mr-1"></span>
							Información básica
						</h5>
						<div class="row">
							<div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 text-center" @mouseover="muestraBtnAvatar = true" @mouseout="muestraBtnAvatar = false">
								<img :src="avatar" style="width:200px;height:200px;border:1px solid #e0e0e0; box-shadow: 0 0 20px rgba(0,0,0,0.2)" class="rounded-circle mt-3">
								<div style="position:absolute;display:block;left:0;right:0;bottom:0;">
									<button class="btn btn-sm btn-primary" @click="nuevoAvatar = true">
										<span class="fa fa-photo mr-1"></span>
										Cambiar
									</button>
								</div>
							</div>
							<div class="col-xs-12 col-sm-6 col-md-8 col-lg-8 col-xl-8">
								<div class="row">
									<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
										<div class="form-group">
											<label for="">Nombre</label>
											<input type="text" class="form-control form-control-sm" v-model="usu.nombre" disabled>
										</div>
									</div>
									<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
										<div class="form-group">
											<label for="">Apellidos</label>
											<input type="text" class="form-control form-control-sm" v-model="usu.apellidos" disabled>
										</div>
									</div>
									<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
										<div class="form-group">
											<label for="">Fecha de nacimiento</label>
											<datepicker
												input-class="form-control form-control-sm"
												v-model="usu.fecha_nacimiento"
												:monday-first="true"
												:language='$dateLang'
												:disabled="!permisos.core_perfil_set_nacimiento"
											></datepicker>
										</div>
									</div>
									<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-center">
										<div class="form-group">
											<label for="">Sexo</label>
											<br>
											<div class="btn-group">
												<button class="btn btn-sm" :class="(usu.sexo === 'mujer') ? 'btn-primary' : ''" @click="usu.sexo = 'mujer'">
													Mujer
												</button>
												<button class="btn btn-sm" :class="(usu.sexo === 'hombre') ? 'btn-primary' : ''" @click="usu.sexo = 'hombre'">
													Hombre
												</button>
												<button class="btn btn-sm" :class="(usu.sexo === 'otro') ? 'btn-primary' : ''" @click="usu.sexo = 'otro'">
													Otros
												</button>
											</div>
										</div>
									</div>

									<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
										<div class="form-group">
											<label for="">Teléfono</label>
											<input type="text" class="form-control form-control-sm" v-model="usu.telefono" disabled>
										</div>
									</div>
									<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
										<div class="form-group">
											<label for="">E-mail</label>
											<input type="text" class="form-control form-control-sm" v-model="usu.email" disabled>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="text-right">
							<button class="btn btn-sm btn-info" @click="guardarDatos()">
								<span class="fa fa-save mr-1"></span>
								Guardar cambios
							</button>
						</div>
					</div>
					<div class="card-body">
						<h5>
							<span class="fa fa-lock mr-1"></span>
							Seguridad de la cuenta
						</h5>
						<b>Cambio de contraseña</b>
						<p class="alert alert-info">
							<span class="fa fa-info-circle mr-1"></span>
							Si quieres cambiar tu contraseña debes escribir tu contraseña actual, y luego la nueva dos veces
						</p>
						<div class="row">
							<div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
								<input type="password" class="form-control form-control-sm" placeholder="Contraseña actual" v-model="pass.passwordAnterior">
							</div>
							<div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
								<input type="password" class="form-control form-control-sm" placeholder="Nueva contraseña" v-model="pass.passwordNueva1">
							</div>
							<div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
								<input type="password" class="form-control form-control-sm" placeholder="Nueva contraseña (repítela)" v-model="pass.passwordNueva2">
							</div>
							<div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
								<button class="btn btn-sm btn-warning btn-block" @click="changePassword()">
									<span class="fa fa-lock mr-1"></span>
									Cambiar contraseña
								</button>
							</div>
						</div>
						<hr>
						<div class="mb-2">
							<b>Autenticación de doble factor</b>
						</div>
						<div class="row">
							<div class="col-xs-12 col-sm-6 col-md-8 col-lg-8 col-xl-8">
								<div class="alert alert-danger">
									<p style="text-align:justify;">
										<span class="fa fa-info-circle mr-1"></span>
										La autenticación de doble factor añade otra capa más de seguridad a tu cuenta de usuario.
									</p>
									<p style="text-align:justify;">
										Debido a la información que se maneja en el sistema, <b>es necesario tenerla activada</b> si quieres acceder
										al SIP desde el exterior de la empresa. Cuando el acceso sea desde la red interna, no se te solicitará.
									</p>
									<p style="text-align:justify;">
										Para poder hacer uso de esta funcionalidad, es necesario que instales en tu dispositivo móvil alguna aplicación
										capaz de generar códigos de un solo uso basados en el tiempo (OTP: One Time Password).
									</p>
									<p style="text-align:justify;">
										Hay muchas gratuítas en las tiendas de aplicaciones, tanto de Apple con de Android. Algunas de las más usadas y confiables son:
										<ul>
											<li>
												<b>Latch: </b>
													<a href="https://play.google.com/store/apps/details?id=com.elevenpaths.android.latch" target="_blank">Android</a>
													/
													<a href="https://itunes.apple.com/es/app/latch-by-elevenpaths/id744999016?mt=8" target="_blank">Apple</a>
											</li>
											<li>
												<b>Google authenticator: </b>
													<a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank">Android</a>
													/
													<a href="https://itunes.apple.com/es/app/google-authenticator/id388497605?mt=8" target="_blank">Apple</a>
											</li>
											<li>
												<b>LastPass authenticator: </b>
													<a href="https://play.google.com/store/apps/details?id=com.lastpass.authenticator" target="_blank">Android</a>
													/
													<a href="https://itunes.apple.com/es/app/lastpass-authenticator/id1079110004?mt=8" target="_blank">Apple</a>
											</li>
										</ul>
									</p>
								</div>
							</div>
							<div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
								<div class="alert alert-warning" v-if="!usu.otps && !configOTPS">
									<div class="text-center">
										<span class="fa fa-unlock m-2" style="font-size:3em;"></span>
									</div>
									<p>Por el momento no tienes activada la verificación en dos pasos.</p>
									<p>para iniciar el proceso de configuración haz click en el botón <b>"Configurar"</b></p>
									<button class="btn btn-danger btn-block" @click="getOTPSecret()">Configurar</button>
								</div>
								<div class="alert alert-info text-center" v-if="!usu.otps && configOTPS">
									<h6>Escanea el código con la app</h6>
									<!--<qrcode :value="configOTPS" :options="{size:200}"></qrcode>-->
									<img :src="configOTPS" alt="">
									<hr>
									<b>Ahora introduce el código generado</b>
									<div class="input-group">
										<input type="text" class="text-center form-control form-control-sm" v-model="verificaToken" placeholder="XXXXXX">
										<div class="input group-btn">
											<button class="btn btn-sm btn-warning" @click="verificarToken()">
												<span class="fa fa-check"></span>
											</button>
										</div>
									</div>
								</div>
								<div class="alert alert-success" v-if="usu.otps">
									<div class="text-center">
										<span class="fa fa-check m-2" style="font-size:3em;"></span>
									</div>
									<p>
										Ya tienes configurado un doble factor de autenticación.
									</p>
									<p>
										Si necesitas cambiarlo pulsa en <b>Configurar otro</b>
									</p>
									<button class="btn btn-sm btn-primary btn-block" @click="getOTPSecret()">
										Configurar otro
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<set-avatar v-if="nuevoAvatar" @cerrar="nuevoAvatar = false" @img="setNuevoAvatar($event)"></set-avatar>
	</div>
</template>

<script>
import API from './apiUsuario'
import SetAvatar from './crop-avatar'
import { mapGetters } from 'vuex'
export default {
	components: {
		'set-avatar': SetAvatar
	},
	data: function () {
		return {
			usu: {
				otps: false
			},
			pass: {
				passwordAnterior: '',
				passwordNueva1: '',
				passwordNueva2: ''
			},
			verificaToken: null,
			configOTPS: false,
			muestraBtnAvatar: false,
			nuevoAvatar: false
		}
	},
	created () {
		// Obtenemos la información del usuario
		API.getUsuario()
			.then(res => {
				res.data.usuario.fecha_nacimiento = (res.data.usuario.fecha_nacimiento) ? new Date(res.data.usuario.fecha_nacimiento * 1000) : null
				this.usu = res.data.usuario
			})
			.catch(e => {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})
	},
	computed: {
		avatar () {
			const sexo = (this.usu.sexo) ? this.usu.sexo : 'otro'
			return (this.usu.avatar && !this.usu.avatar.match(/\.svg$/)) ? this.usu.avatar : '/static/recursos/' + sexo + '.svg'
		},
		...mapGetters({
			permisos: 'permisos/permisos'
		})
	},
	methods: {
		setNuevoAvatar (data) {
			this.usu.avatar = data
		},
		guardarDatos () {
			API.setUsuario(this.usu)
				.then(res => {
					this.$store.commit('alertas/alert', {
						titulo: 'Datos guardados',
						mensaje: 'Se han guardado los cambios correctamente'
					})

					// Ahora actualizamos los datos de la sesión
					this.$store.dispatch('session/getSesion')
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		changePassword () {
			API.changePassword(this.pass)
				.then(res => {
					this.$store.commit('alertas/alert', {
						titulo: 'Cambio correcto',
						mensaje: `
						Se ha actualizado tu contraseña correctamente.\n
						Te en cuenta que el resto de servicios, como el correo electrónico, el acceso a tu ordenador, la mensajería interna (pidgin), etc., comparten esta contraseña, por lo que deberás actualizar los programas que acceden a estos servicios para que continuen funcionando.`
					})
					this.pass.passwordAnterior = ''
					this.pass.passwordNueva1 = ''
					this.pass.passwordNueva2 = ''
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		getOTPSecret () {
			API.setOTP({getSecret: true})
				.then(res => {
					this.usu.otps = null
					this.configOTPS = res.data.uri
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		verificarToken () {
			API.setOTP({verificar: this.verificaToken})
				.then(res => {
					this.usu.otps = 'configurado'
					this.configOTPS = null
					this.$store.commit('alertas/alert', {
						titulo: 'Correcto',
						mensaje: 'Has configurado correctamente tu doble factor de autenticación'
					})
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/mi-perfil/mi-perfil.vue